import {alias, createModelSchema, identifier, primitive, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";

export class ActivationType extends Cloneable {
    static REWARD = new ActivationType(1, "DEACTIVATE_ON_RECIEVE");
    //static REWARD_1 = new ActivationType(2, "TIME_DEPENDENT");
    static REWARD_2 = new ActivationType(3, "ACTIVATE_BY_CONDITION");

    static _values = [
        this.REWARD,
        //this.REWARD_1,
        this.REWARD_2
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ActivationType.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ActivationType) {
            return ActivationType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ActivationType) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ActivationType());
        } else if (target instanceof ActivationType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ActivationType, {
    _id: alias("id", identifier()),
    _name: alias("name", primitive())
});